class TabFeaturedCollection extends HTMLElement {
  constructor() {
    super();
    console.log(".....TabFeaturedCollection....执行......")
    this.tab_titles = $(this).find('.tab_titles div');
    this.tab_contents = $(this).find('.tab_content');
    this.addClick();
  }

  addClick(){
    console.log("绑定点击事件....")
    const that = this;
    that.tab_titles.on('click',function(){
      if(!$(this).hasClass('active')){
        $(this).addClass('active').siblings().removeClass('active');
        let _idx = $(this).index();
        that.tab_contents.eq(_idx).addClass('active').siblings().removeClass('active');
      }
    })
  }
}

customElements.define('tab-featured-collection', TabFeaturedCollection);